import { buildProps } from '@ll-plus/utils'
import { footerShadowPlacement } from '../../new-drawer'

import type { ExtractPropTypes } from 'vue'
import type BreadcrumbCard from './breadcrumb-card.vue'

export const breadcrumbCardProps = buildProps({
  // buildProps和defineProps一样
  /**
   * @description 滚动是否显示底部阴影
   */
  isShowFooterShadow: {
    type: Boolean,
    default: true,
  },
  /**
   * @description 决定底部阴影的方向(外部和内部）,默认由内容区域来决定
   */
  footerShadowPlacement: {
    type: String,
    values: footerShadowPlacement,
    default: 'inner',
  },
  /**
   * @description 最外层的class
   */
  rootClass: {
    type: String,
  },
  /**
   * @description 设置BreadcrumbCard的z-index
   */
  zIndex: {
    type: Number,
    default: 1000,
  },
  /**
   * @description 指定BreadcrumbCard挂载的节点，并在容器内展现，false为挂载在当前位置
   */
  // getContainer: {
  //   type: definePropType<() => HTMLElement | HTMLElement | false>(Object)
  // },
  /**
   * @description  是否支持键盘esc关闭
   */
  keyboard: {
    type: Boolean,
    default: true,
  },
  /**
   * @description 是否可见
   */
  visible: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 标题
   */
  title: {
    type: String,
    default: '标题',
  },
} as const)

export const breadcrumbCardEmits = {
  close: (bool: boolean) => bool, // 点击左侧返回关闭事件
  'update:visible': (bool: boolean) => bool, // 关闭打开弹窗
}

// props
export type BreadcrumbCardProps = ExtractPropTypes<typeof breadcrumbCardProps> // ExtractPropTypes和defineCpmponent类似

// instance
export type BreadcrumbCardInstance = InstanceType<typeof BreadcrumbCard>
